import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConstants } from '../../shared/constants.service';

export type GlobalSearchGroupKey = 'events' | 'products' | 'clients';

export interface GlobalSearchGroup<T = any> {
  total_entries: number;
  items: T[];
}

export interface GlobalSearchResponse {
  query: string;
  results: Partial<Record<GlobalSearchGroupKey, GlobalSearchGroup>>;
}

@Injectable({ providedIn: 'root' })
export class GlobalSearchService {
  baseUrl: string;

  constructor(private http: HttpClient) {
    this.baseUrl = AppConstants.baseUrl;
  }

  search(query: string, limit: number = 5): Observable<GlobalSearchResponse> {
    const params = new HttpParams().set('q', query).set('limit', String(limit));
    return this.http.get<GlobalSearchResponse>(this.baseUrl + '/search', { params });
  }
}
